export const identifications = [
  {
    value: "PF",
    label: "PF (Pessoa Física)",
  },
  {
    value: "PJ",
    label: "PJ (Pessoa Jurídica)",
  },
  {
    value: "AMBOS",
    label: "PF e PJ (Ambos)",
  },
];

export const labelIdentification = identifications.reduce((obj, item) => {
  obj[item.value] = item.label;
  return obj;
}, {});
